import React, { useState } from 'react';
import { MDBBtn } from 'mdb-react-ui-kit';
import PhotographerAvailabilityModal from './PhotographerAvailabilityModal';

/** True when photographer asked for services but admin has not assigned any specialization yet. */
export const needsServiceAssignmentBeforeVerify = (item: any) => {
    const requested = (item?.requested_specialization || []).filter(Boolean);
    const assigned = (item?.specialization || []).filter(Boolean);
    return requested.length > 0 && assigned.length === 0;
};

const RenderItem = ({ toggleOpen, item, updateVerifyStatus, requested, err, isPending, assignSpecialization, specializationOptions, token, isMainAdmin = true }: any) => {
//     "working_details": {
//         "totalHoursWorked": 0,
//         "paidForHours": 0
//     },
//     "is_blocked": false,
//     "_id": "65edb10970aa1b8bcb0ff161",
//     "email": "something1@yopmail.com",
//     "contact": "9969486835",
//     "profileCategories": [
//         "Traditional Photographer",
//         "Candid Photographer",
//         "Cinematographer"
//     ],
//     "categoriesWorked": [
//         "Personal",
//         "Corporate",
//         "Social-Media/Vlog",
//         "Others",
//         "Product"
//     ],
//     "name": "Namr",
//     "bio": "Bio",
//     "profile_pic": "https://assets.change.org/photos/6/eg/hh/hHeghHphXlJirUP-800x450-noPad.jpg?1602505595",
//     "instagram": "https://a.com",
//     "facebook": "https://a.com",
//     "resumeUrl": "https://a.com",
//     "experience": "2 years",
//     "addl_skills": "Good stuff",
//     "ready_to_travel": "Yes",
//     "cameras_owned": [
//         "Sony",
//         "Sony1",
//         "Sony2"
//     ],
//     "lens_owned": [
//         "Lens",
//         "Lens 2"
//     ],
//     "flash_owned": [
//         "Flash",
//         "Flash1",
//         "Flash3"
//     ],
//     "addl_equipments": "A lot extra equips ",
//     "is_verified": true,
//     "user_type": "photographer",
//     "reg_medium": "normal",
//     "referredBy": null,
//     "__v": 0,
//     "createdAt": "2025-05-05T10:37:24.054Z"
// }

    {
        const [availabilityModalOpen, setAvailabilityModalOpen] = useState(false);
        const specChoices: string[] = Array.isArray(specializationOptions) ? specializationOptions : [];
        // Pre-check only the requested services that are still real Admin
        // services — otherwise a stale/removed request (not shown as a
        // checkbox at all now) would still silently ride along in
        // selectedSpecs and get assigned the moment admin clicks Assign.
        const [selectedSpecs, setSelectedSpecs] = useState<string[]>(
            (item?.requested_specialization || []).filter((s: string) => specChoices.includes(s))
        );

        const onCopy = (textToCopy: string, event: any) => {
            if (event.target.style.opacity === "0.5") {
                return;
            }

            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    if (event?.target) {
                        event.target.style.cursor = "default";
                        event.target.style.opacity = "0.5";
                    }
                    //console.log("Text copied to clipboard successfully!");
                })
                .catch(err => {
                    console.error("Failed to copy text: ", err);
                });
        }

        const toggleSpec = (spec: string) => {
            setSelectedSpecs((prev: string[]) =>
                prev.includes(spec) ? prev.filter((s: string) => s !== spec) : [...prev, spec]
            );
        }

        if (isPending) {
            return (
                <>
                    <tr>
                        <td onClick={() => { toggleOpen(item) }} style={{ cursor: "pointer", paddingBottom: 4, verticalAlign: 'bottom', borderBottom: 'none' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src="assets/images/profile.png" alt="image" />
                                <span className="ps-2">{item?.name}</span>
                            </div>
                        </td>
                        <td style={{ paddingBottom: 4, verticalAlign: 'bottom', borderBottom: 'none' }}><span>{item?.email}</span></td>
                        <td style={{ paddingBottom: 4, verticalAlign: 'bottom', borderBottom: 'none' }}><span style={{ width: 'max-content' }}>{item?.countryCode && item?.contact ? `${item?.countryCode} ${item?.contact}` : "-"}</span></td>
                        <td style={{ paddingBottom: 4, verticalAlign: 'bottom', borderBottom: 'none' }}>
                            {Array.isArray(item?.requested_specialization) && item.requested_specialization.length ? item.requested_specialization.map((s: string) => (
                                <div key={s} className="badge badge-outline-info" style={{ marginRight: 5, marginBottom: 4, fontSize: 12 }}>{s}</div>
                            )) : <span>-</span>}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} style={{ paddingTop: 0, paddingBottom: 14, borderTop: 'none' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: '6px 18px' }}>
                                <span style={{ fontSize: 11, fontWeight: 700, opacity: 0.5, textTransform: 'uppercase', letterSpacing: 0.5, marginRight: 4 }}>
                                    Assign services:
                                </span>
                                {specChoices.map((spec: string) => {
                                    const checked = selectedSpecs.includes(spec);
                                    return (
                                    <label key={spec} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13, lineHeight: 1.4 }}>
                                        <span style={{
                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                            width: 20, height: 20, borderRadius: 5, flexShrink: 0,
                                            background: checked ? 'rgba(129, 199, 132, 0.95)' : 'rgba(255,255,255,0.95)',
                                            border: checked ? '2px solid #2e7d32' : '2px solid rgba(0,0,0,0.15)',
                                        }}>
                                            <input
                                                type="checkbox"
                                                checked={checked}
                                                onChange={() => toggleSpec(spec)}
                                                style={{ width: 13, height: 13, margin: 0, accentColor: '#1b5e20' }}
                                            />
                                        </span>
                                        {spec}
                                    </label>
                                    );
                                })}
                                {isMainAdmin ? (
                                    <MDBBtn
                                        size='sm'
                                        color='success'
                                        disabled={selectedSpecs.length === 0 || requested}
                                        onClick={(e: any) => { e.stopPropagation(); assignSpecialization(item._id, selectedSpecs); }}
                                        style={{ marginLeft: 'auto' }}
                                    >
                                        Assign
                                    </MDBBtn>
                                ) : null}
                            </div>
                        </td>
                    </tr>
                </>
            );
        }

        // Prefer the bank holder name when the photographer has filled in bank
        // details — that matches the name on the account we pay out to, which
        // is what admin needs to verify against KYC. Falls back to the name the
        // photographer chose at registration when bank details aren't entered
        // yet. Empty-string / whitespace bank holder is treated as "not set".
        const bankHolder = String(item?.bank_details?.bank_holder ?? '').trim();
        const registrationName = String(item?.name ?? '').trim();
        const displayName = bankHolder || registrationName || '-';
        const showRegistrationSubtitle = !!bankHolder && !!registrationName && bankHolder.toLowerCase() !== registrationName.toLowerCase();

        return (
            <>
                <tr id="__clickableTableRow">
                    <td onClick={() => { toggleOpen(item) }} style={{ cursor: "pointer" }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src="assets/images/profile.png" alt="image" />
                            <div className="ps-2" style={{ display: 'flex', flexDirection: 'column' }}>
                                <span>{displayName}</span>
                                {showRegistrationSubtitle ? (
                                    <span
                                        title="Name used at sign-up. Replaced by bank account holder name once bank details are saved."
                                        style={{ fontSize: 11, opacity: 0.55, marginTop: 1 }}
                                    >
                                        signup: {registrationName}
                                    </span>
                                ) : null}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                            <span>{item?.email}</span>
                            <svg onClick={(e) => { onCopy(item?.email, e) }} style={{ cursor: 'pointer' }} fill="#FFF" height="18" width="18" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                                <g>
                                    <path d="M53.9791489,9.1429005H50.010849c-0.0826988,0-0.1562004,0.0283995-0.2331009,0.0469999V5.0228
                                                                C49.7777481,2.253,47.4731483,0,44.6398468,0h-34.422596C7.3839517,0,5.0793519,2.253,5.0793519,5.0228v46.8432999
                                                                c0,2.7697983,2.3045998,5.0228004,5.1378999,5.0228004h6.0367002v2.2678986C16.253952,61.8274002,18.4702511,64,21.1954517,64
                                                                h32.783699c2.7252007,0,4.9414978-2.1725998,4.9414978-4.8432007V13.9861002
                                                                C58.9206467,11.3155003,56.7043495,9.1429005,53.9791489,9.1429005z M7.1110516,51.8661003V5.0228
                                                                c0-1.6487999,1.3938999-2.9909999,3.1062002-2.9909999h34.422596c1.7123032,0,3.1062012,1.3422,3.1062012,2.9909999v46.8432999
                                                                c0,1.6487999-1.393898,2.9911003-3.1062012,2.9911003h-34.422596C8.5049515,54.8572006,7.1110516,53.5149002,7.1110516,51.8661003z
                                                                M56.8888474,59.1567993c0,1.550602-1.3055,2.8115005-2.9096985,2.8115005h-32.783699
                                                                c-1.6042004,0-2.9097996-1.2608986-2.9097996-2.8115005v-2.2678986h26.3541946
                                                                c2.8333015,0,5.1379013-2.2530022,5.1379013-5.0228004V11.1275997c0.0769005,0.0186005,0.1504021,0.0469999,0.2331009,0.0469999
		                                                        h3.9682999c1.6041985,0,2.9096985,1.2609005,2.9096985,2.8115005V59.1567993z" stroke="#FFF" />
                                    <path d="M38.6031494,13.2063999H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0158005
                                                                c0,0.5615997,0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4542999,1.0158997-1.0158997
                                                                C39.6190491,13.6606998,39.16465,13.2063999,38.6031494,13.2063999z" stroke="#FFF" />
                                    <path d="M38.6031494,21.3334007H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0157986
                                                                c0,0.5615005,0.4544001,1.0159016,1.0159006,1.0159016h22.3491974c0.5615005,0,1.0158997-0.454401,1.0158997-1.0159016
                                                                C39.6190491,21.7877007,39.16465,21.3334007,38.6031494,21.3334007z" stroke="#FFF" />
                                    <path d="M38.6031494,29.4603004H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
                                                                s0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4543991,1.0158997-1.0158997
                                                                S39.16465,29.4603004,38.6031494,29.4603004z" stroke="#FFF" />
                                    <path d="M28.4444485,37.5872993H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
                                                                s0.4544001,1.0158997,1.0159006,1.0158997h12.1904964c0.5615025,0,1.0158005-0.4543991,1.0158005-1.0158997
                                                                S29.0059509,37.5872993,28.4444485,37.5872993z" stroke="#FFF" />
                                </g>
                            </svg>
                        </div>
                    </td>
                    <td>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                            <span style={{ width: 'max-content' }}>{item?.countryCode && item?.contact ? `${item?.countryCode} ${item?.contact}` : "-"}</span>
                            {item?.countryCode && item?.contact ? <svg onClick={(e) => { onCopy(`${item?.countryCode} ${item?.contact}`, e) }} style={{ cursor: 'pointer' }} fill="#FFF" height="18" width="18" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                                <g>
                                    <path d="M53.9791489,9.1429005H50.010849c-0.0826988,0-0.1562004,0.0283995-0.2331009,0.0469999V5.0228
                                                                C49.7777481,2.253,47.4731483,0,44.6398468,0h-34.422596C7.3839517,0,5.0793519,2.253,5.0793519,5.0228v46.8432999
                                                                c0,2.7697983,2.3045998,5.0228004,5.1378999,5.0228004h6.0367002v2.2678986C16.253952,61.8274002,18.4702511,64,21.1954517,64
                                                                h32.783699c2.7252007,0,4.9414978-2.1725998,4.9414978-4.8432007V13.9861002
                                                                C58.9206467,11.3155003,56.7043495,9.1429005,53.9791489,9.1429005z M7.1110516,51.8661003V5.0228
                                                                c0-1.6487999,1.3938999-2.9909999,3.1062002-2.9909999h34.422596c1.7123032,0,3.1062012,1.3422,3.1062012,2.9909999v46.8432999
                                                                c0,1.6487999-1.393898,2.9911003-3.1062012,2.9911003h-34.422596C8.5049515,54.8572006,7.1110516,53.5149002,7.1110516,51.8661003z
                                                                M56.8888474,59.1567993c0,1.550602-1.3055,2.8115005-2.9096985,2.8115005h-32.783699
                                                                c-1.6042004,0-2.9097996-1.2608986-2.9097996-2.8115005v-2.2678986h26.3541946
                                                                c2.8333015,0,5.1379013-2.2530022,5.1379013-5.0228004V11.1275997c0.0769005,0.0186005,0.1504021,0.0469999,0.2331009,0.0469999
		                                                        h3.9682999c1.6041985,0,2.9096985,1.2609005,2.9096985,2.8115005V59.1567993z" stroke="#FFF" />
                                    <path d="M38.6031494,13.2063999H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0158005
                                                                c0,0.5615997,0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4542999,1.0158997-1.0158997
                                                                C39.6190491,13.6606998,39.16465,13.2063999,38.6031494,13.2063999z" stroke="#FFF" />
                                    <path d="M38.6031494,21.3334007H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0157986
                                                                c0,0.5615005,0.4544001,1.0159016,1.0159006,1.0159016h22.3491974c0.5615005,0,1.0158997-0.454401,1.0158997-1.0159016
                                                                C39.6190491,21.7877007,39.16465,21.3334007,38.6031494,21.3334007z" stroke="#FFF" />
                                    <path d="M38.6031494,29.4603004H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
                                                                s0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4543991,1.0158997-1.0158997
                                                                S39.16465,29.4603004,38.6031494,29.4603004z" stroke="#FFF" />
                                    <path d="M28.4444485,37.5872993H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
                                                                s0.4544001,1.0158997,1.0159006,1.0158997h12.1904964c0.5615025,0,1.0158005-0.4543991,1.0158005-1.0158997
                                                                S29.0059509,37.5872993,28.4444485,37.5872993z" stroke="#FFF" />
                                </g>
                            </svg> : null}
                        </div>
                    </td>
                                        <td style={{ verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {!isMainAdmin ? (
                            <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem' }}>View only</span>
                        ) : (
                        <>
                        {!item?.is_admin_verified ? (
                            <MDBBtn
                                disabled={needsServiceAssignmentBeforeVerify(item) || requested}
                                title={needsServiceAssignmentBeforeVerify(item) ? 'Assign services on Pending Assignment tab first' : undefined}
                                onClick={(e) => { e.stopPropagation(); updateVerifyStatus(item?._id); }}
                                color='primary'
                                rippleColor='light'
                            >
                                Verify
                            </MDBBtn>
                        ) : (
                            <MDBBtn onClick={(e) => { e.stopPropagation(); updateVerifyStatus(item?._id); }} color='secondary' rippleColor='light'>Block</MDBBtn>
                        )}
                        </>
                        )}
                        </div>
                        {needsServiceAssignmentBeforeVerify(item) ? (
                            <span style={{ fontSize: 11, color: '#ffb74d', maxWidth: 220 }}>Assign requested services first (Pending Assignment)</span>
                        ) : null}
                        </div>
                    </td>
                    {/* <td> Dashboard </td> */}
                    {/* <td> Credit card </td> */}
                    <td>{item?.already_assigned_order ? "Yes" : "No"}</td>
                    {/* <td>
                        {item?.ready_to_travel}
                    </td> */}
                    <td style={{ whiteSpace: 'normal', maxWidth: 220, wordBreak: 'break-word' }}> {item?.experience}</td>
                    {/* Availability viewer — read-only calendar modal. Click-stop
                        so the click doesn't bubble up to the row (which opens the
                        photographer details modal). */}
                    <td>
                        <MDBBtn
                            size='sm'
                            color='info'
                            onClick={(e: any) => { e.stopPropagation(); setAvailabilityModalOpen(true); }}
                        >
                            View
                        </MDBBtn>
                    </td>
                </tr>
                {availabilityModalOpen ? (
                    <PhotographerAvailabilityModal
                        open={availabilityModalOpen}
                        toggleOpen={() => setAvailabilityModalOpen(false)}
                        photographer={item}
                        token={token}
                    />
                ) : null}
            </>
        );
    }
}

export default RenderItem;